import { render, staticRenderFns } from "./EtiquetaOpmeConsigProcedimento.vue?vue&type=template&id=5834d316&scoped=true&"
import script from "./EtiquetaOpmeConsigProcedimento.vue?vue&type=script&lang=js&"
export * from "./EtiquetaOpmeConsigProcedimento.vue?vue&type=script&lang=js&"
import style0 from "./EtiquetaOpmeConsigProcedimento.vue?vue&type=style&index=0&id=5834d316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834d316",
  null
  
)

export default component.exports